<template>
  <div
    class="overflow-y-auto"
    :style="containerStyle"
    ref="scroller"
    @scroll="checkScroll"
  >
    <div class="space-y-4">
      <a
        class="block z-40 cursor-pointer zoom"
        v-for="(item, i) in results"
        :key="i"
        :href="`/proposal/details/${item.id}`"
      >
        <div
          class="rounded-2xl p-4 text-xs relative"
          :class="{
            'bg-white-005': item.type == 'active',
          }"
          :style="{
            border: item.type != 'active' ? '1px solid #ffffff1a' : '',
          }"
        >
          <div class="flex items-center mb-4">
            <UiImg
              class="w-10 h-10 overflow-hidden rounded-full mr-2"
              :src="
                daoPageInfo.vueState.info.logo ||
                require('@/assets/icons/nftnologo.avif')
              "
            ></UiImg>
            <div class="flex-1 min-w-0">
              <div class="flex justify-between">
                <div class="flex flex-col">
                  <div class="flex items-center">
                    By
                    <span class="text-secondary-7 mx-2">
                      <EnsAddress
                        :address="item.author"
                        :size="5"
                        :isCore="item.isCore"
                      ></EnsAddress>
                    </span>
                  </div>
                  <div>
                    <span style="color: #ffffff66">
                      {{
                        item.state === 'active'
                          ? 'Closes'
                          : item.state === 'pending'
                          ? 'Starts'
                          : 'Closed'
                      }}
                      {{ formatDateText(item.end * 1000) }}
                    </span>
                  </div>
                </div>

                <div class="flex items-center">
                  <div>
                    <a
                      @click.stop=""
                      v-if="item.platform"
                      :href="item.proposalUrl"
                      target="_blank"
                      class="z-top"
                    >
                      <i
                        class="iconfont text-xl z-top cursor-pointer"
                        :class="platformIconOnlyStyle(item.platform)"
                      ></i
                    ></a>
                  </div>
                  <div
                    class="
                      h-6
                      ml-6
                      w-max
                      px-2
                      flex
                      items-center
                      justify-center
                      rounded
                      font-bold
                      capitalize
                    "
                    :style="
                      item.state == 'active'
                        ? ''
                        : item.state == 'pending'
                        ? ''
                        : 'background:#FFFFFF1A;color:#FFFFFF66;'
                    "
                    :class="{
                      [daoPageInfo.vueState.customClass === 'ape'
                        ? 'bg-ape-solid'
                        : 'bg-aavegotchi-solid']:
                        activeType.indexOf(item.state) !== -1 &&
                        daoPageInfo.isCustom.value,
                      [daoPageInfo.vueState.customClass === 'ape'
                        ? 'bg-ape-secondary'
                        : 'bg-aavegotchi-secondary']:
                        item.state == 'pending' && daoPageInfo.isCustom.value,
                      'bg-inputActive':
                        activeType.indexOf(item.state) !== -1 &&
                        !daoPageInfo.isCustom.value,
                      'bg-success':
                        item.state == 'pending' && !daoPageInfo.isCustom.value,
                    }"
                  >
                    {{ item.state.toLowerCase() }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div @click="handleProposalClick(item.id)">
            <span
              v-if="item.category"
              class="
                h-5
                text-xs
                uppercase
                rounded
                px-2
                py-1
                mr-2
                bg-white-010
                whitespace-nowrap
              "
              >{{ item.category }}</span
            >
            <div class="cursor-pointer">
              <div class="my-4 hover:underline">{{ item.title }}</div>
              <div class="space-y-4">
                <div
                  class="relative w-full h-8"
                  v-for="(choice, j) in item.choices"
                  :key="j"
                >
                  <BarLoadingEffect
                    :fillColor="
                      daoPageInfo.isCustom.value
                        ? 'bg-' + daoPageInfo.vueState.customClass + '-solid'
                        : 'bg-secondary-7'
                    "
                    :value="choice.score"
                    :total="item.scoresTotal"
                  />

                  <div
                    class="
                      relative
                      z-30
                      flex
                      w-full
                      h-full
                      justify-between
                      rounded
                      items-center
                      px-4
                      text-xs
                      bg-white-005
                      text-white-040
                    "
                  >
                    <div class="text-white-040 line-clamp-1">
                      <span class="font-bold mr-4 text-whitebase">{{
                        choice.choice
                      }}</span>
                      ({{ choice.voterCount }} Voters /
                      {{ formatVal(choice.score, { omit: true }) }} Votes
                      {{
                        choice.score === 0 || item.scoresTotal == 0
                          ? 0
                          : ((choice.score / item.scoresTotal) * 100).toFixed(
                              2,
                            )
                      }}%)
                    </div>
                    <!-- <div class="font-bold text-whitebase">
                      {{
                        choice.score === 0 || item.scoresTotal == 0
                          ? 0
                          : ((choice.score / item.scoresTotal) * 100).toFixed(
                              2,
                            )
                      }}%
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </a>
    </div>

    <div v-if="isEmpty" class="flex justify-center font-bold text-gray-level">
      No Data.
    </div>

    <div class="w-full" v-if="loading || (!isEmpty && results.length === 0)">
      <Skeletor
        v-for="(item, i) in [1, 2, 3]"
        :key="i"
        in
        class="h-72 mb-4 rounded"
      ></Skeletor>
    </div>
  </div>
</template>
<script setup>
import { queryOvDaoProposal } from '@/api/dao';
import UiImg from '@/components/UiImg.vue';
import { platformIconOnlyStyle } from '@/constants/platforms';
import { useReqPages } from '@/hooks';
import { formatDateText, formatVal } from '@/utils';
import { withThrottling } from '@/utils/with';
import EnsAddress from '@/views/Home/component/EnsAddress.vue';
import { useInfiniteScroll } from '@vueuse/core';
import { inject, onMounted, ref, watch } from 'vue';

import { useRouter } from 'vue-router';

import { Skeletor } from 'vue-skeletor';
import BarLoadingEffect from './BarLoadingEffect.vue';
const scroller = ref(null);
const props = defineProps({
  scrollTriggered: Boolean,
  containerStyle: String,
  containerRef: Object,
  category: { type: String, default: 'ALL' },
  type: {
    type: Object,
    default() {
      return { label: 'All', value: 'all' };
    },
  },
  votesSort: {
    type: Array,
    default() {
      return [-1];
    },
  },
});
const checkScroll = () => {
  const containerElement = scroller.value;

  if (
    containerElement.scrollTop + containerElement.clientHeight >=
    containerElement.scrollHeight
  ) {
    loadNext();
  }
};
const $router = useRouter();
const activeType = ['active', 'succeeded', 'queued'];

const daoPageInfo = inject('daoPageInfo');

const { loadNext, loadRest, results, loading, isEmpty } = useReqPages(
  async (page, cancel) => {
    const sortTag = props.votesSort[0];

    const res = await queryOvDaoProposal(
      daoPageInfo.vueState.info.id,
      page,
      props.type.value,
      {
        orderItem: sortTag == -1 ? '' : 'votes',
        orderType: sortTag != 1 ? 'desc' : 'asc',
        category: props.category,
      },
      cancel,
    );

    const result = {
      lists: res.records,
      rows: res.size,
      total: res.total,
      pages: res.pages,
    };
    return result;
  },
);

useInfiniteScroll(window, withThrottling(loadNext), { distance: 44 });
const handleProposalClick = (id) => {
  $router.push(`/proposal/details/${id}`);
};

watch(
  () => props.scrollTriggered,
  () => console.log('scroll triggered'),
);
watch(
  () => [props.type.value, props.category],
  () => {
    loadRest(true);
  },
);

watch(
  () => props.votesSort[0],
  () => {
    loadRest(true);
  },
);
onMounted(() => {
  loadRest(true);
});
</script>

<style scoped>
.zoom {
  transform: scale(0.99);
}
.zoom:hover {
  transform: scale(
    1
  ); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}
</style>
